import React, { useEffect, useState } from "react";
import useDatabaseRecipes from "../../hooks/useDatabaseRecipes";
import BackdropWrapper from "../modals/BackdropWrapper";
import ConfirmCartModal from "./ConfirmCartModal.js";
import { useLocation } from "react-router";
import Footer from "../Footer.js";
import Nav from "../Nav.js";
import Cart from "./Cart.js";
import { auth } from "../../authentication/firebase.js";
import { useDispatch, useSelector } from "react-redux";
import { userRecipesActions } from "../../store/userRecipesSlice";
import { fetchCart } from "./cartFunctions";

export default function CartPage() {
  const [backdrop, setBackdrop] = useState(false);
  const urlPath = useLocation().pathname;
  const cartRoute = useSelector(
    (state) => state.userRecipes.cartRecipes.cartRoute
  );
  const dispatch = useDispatch();

  const reviewCartHandler = () => {
    setBackdrop((prev) => !prev);
  };

  async function getCartRecipes() {
    console.log("route", urlPath)
    try {
      dispatch(userRecipesActions.setCartRecipesLoading(true));
      const { cartRecipes, noOfRecipes, cartRoute } = await fetchCart(urlPath);
      console.log("no of recipes", noOfRecipes, cartRecipes);
      dispatch(
        userRecipesActions.setCartRecipes({
          cartRecipes,
          noOfRecipes,
          cartRoute,
        })
      );
    } catch (e) {
      console.log("error while getting cart recipes", e);
    }
  }

  useEffect(() => {
    if (cartRoute !== urlPath) getCartRecipes();
  }, [urlPath]);

  return (
    <>
      <Nav />
      <BackdropWrapper
        handleBackdrop={reviewCartHandler}
        smallSize={false}
        element={<ConfirmCartModal backdropHandler={reviewCartHandler} />}
        open={backdrop}
      />
      <Cart reviewCartHandler={reviewCartHandler} />
      <Footer />
    </>
  );
}
